module.exports = __webpack_public_path__ + "img/heart-hover.1fe87941.svg";